<template>
    <el-dialog title="取消出库" :visible.sync="outCancelDialog" width="520px" :before-close="handleDialogClose" :close-on-click-modal="false" class="custom-form-dialog">
        <el-form ref="formData" :rules="formRules" :model="formData" label-position="top">
            <el-form-item label="取消原因" prop="note">
                <el-input size="small" v-model="formData.note" type="textarea" :rows="6" placeholder="请输入取消原因"></el-input>
            </el-form-item>

        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click.stop="handleDialogClose">取消</el-button>
            <el-button type="primary" :disabled="BtnDisabled" @click.stop="handleDialogConfirm" >确定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { approvalSetCateAdd } from "@/api/index.js"
export default {
    name: "out_cancel_product",
    props: {
        outCancelDialog: {
            type: Boolean,
            default: false
        },
        warehouseEditId: {
            type: Number,
            default: 0
        },
    },
    data() {
        return {
            BtnDisabled:false,
            formData: {
                note: "",
            },
            formRules: {
                note: [
                    {required: true, message: "请输入取消原因"}
                ]
            },
            userList: []
        }
    },
    methods: {
        handleDialogClose() {
            this.$emit("update:outCancelDialog", false)
        },
        handleDialogConfirm() {
            this.$refs.formData.validate(valid => {
                if (valid) {
                    this.BtnDisabled = true
                    // approvalSetCateAdd({name: this.formData.name}).then(res=> {
                    //     if(res.code === 200) {
                    //         this.$message({
                    //             type: 'success',
                    //             message: res.message,
                    //             duration: 1500,
                    //             onClose: () => {
                    //                 this.handleDialogClose()
                    //                 this.$emit('success')
                    //                 this.BtnDisabled = false
                    //             }
                    //         })
                    //     }else{
                    //         this.BtnDisabled = false
                    //     }
                    // })
                }
            })
        },

    }
}
</script>
